/* eslint-disable */
import React from 'react';

const IconSortDown = () => (
    <svg width="22" height="14" viewBox="0 0 22 14">
        <g fill="none" fillRule="evenodd" strokeLinecap="square" className="fase-2">
            <g transform="translate(-1476 -893)">
                <g transform="translate(0 640)">
                    <g transform="translate(575 113)">
                        <g
                            transform="translate(686 129)">
                            <g transform="translate(217 11)">
                                <path d="M0,9.5 C0,9.5 1,10.5 3,12.5 L6,9.5"/>
                                <line x1="3" x2="3" y1="11.5" y2="1"/>
                                <line x1="10.5" x2="18.5" y1="1" y2="1"/>
                                <line x1="10.5" x2="15.5" y1="7" y2="7"/>
                                <line x1="10.5" x2="12.5" y1="13" y2="13"/>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export default IconSortDown;
